import { Route, Routes } from 'react-router';
import { lazy, Suspense } from 'react';
import { PublicRoute } from './PublicRoute';
import { AuthLoading } from '@src/components';
import {
  ROUTE_FORGET_PASSWORD,
  ROUTE_FORGET_PASSWORD_SUCCESS,
  ROUTE_REGISTER,
  ROUTE_VERIFY_EMAIL,
  ROUTE_AUTH_VERIFY_EMAIL,
  ROUTE_EMAIL_VERIFIED,
  ROUTE_RESET_PASSWORD,
} from '@src/constants/URLS.const';
import { ForgotPasswordSuccessful } from '@src/pages/Auth/ForgotPasswordSuccessful';

export function AuthenticationRoutes() {
  const SignUp = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.SignUp,
    }))
  );

  const SignIn = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.SignIn,
    }))
  );

  const ForgotPassword = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.ForgotPassword,
    }))
  );

  const ResetPassword = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.ResetPassword,
    }))
  );

  const AuthCallback = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.AuthCallback,
    }))
  );

  const VerifyEmail = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.VerifyEmail,
    }))
  );

  const VerifyEmailLink = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.VerifyEmailLink,
    }))
  );

  const EmailVerified = lazy(() =>
    import('@src/pages/Auth').then((module) => ({
      default: module.EmailVerified,
    }))
  );

  return (
    <Suspense fallback={<AuthLoading />}>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route index element={<SignIn />} />
          <Route path={ROUTE_REGISTER} element={<SignUp />} />
          <Route path={ROUTE_FORGET_PASSWORD} element={<ForgotPassword />} />
          <Route
            path={`${ROUTE_FORGET_PASSWORD}/${ROUTE_FORGET_PASSWORD_SUCCESS}`}
            element={<ForgotPasswordSuccessful />}
          />
          <Route path={ROUTE_RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={`auth/${ROUTE_RESET_PASSWORD}`} element={<ResetPassword />} />
          <Route path='/auth/callback' element={<AuthCallback />} />
          <Route path={ROUTE_VERIFY_EMAIL} element={<VerifyEmail />} />
          <Route path={ROUTE_AUTH_VERIFY_EMAIL} element={<VerifyEmailLink />} />
          <Route path={ROUTE_EMAIL_VERIFIED} element={<EmailVerified />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
